import { useEffect, useState } from 'react';
import { fetchActiveOrders, type ActiveOrder } from '../lib/appointments';

interface State {
  orders: ActiveOrder[];
  isLoading: boolean;
  error: string | null;
}

export function useActiveOrders(accountId: string | null | undefined): State {
  const [state, setState] = useState<State>({
    orders: [],
    isLoading: false,
    error: null,
  });

  useEffect(() => {
    if (!accountId) {
      setState({ orders: [], isLoading: false, error: null });
      return;
    }

    let cancelled = false;
    setState({ orders: [], isLoading: true, error: null });

    fetchActiveOrders(accountId)
      .then((orders) => {
        if (!cancelled) setState({ orders, isLoading: false, error: null });
      })
      .catch((err) => {
        if (!cancelled) {
          setState({
            orders: [],
            isLoading: false,
            error: err instanceof Error ? err.message : 'Kon orders niet laden',
          });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [accountId]);

  return state;
}
